// Values are shared by CSS transitions and the route's Web Animations effects.
export const reducedMotion = () => window.matchMedia("(prefers-reduced-motion: reduce)").matches;
export const motionTiming = () => {
  const css = getComputedStyle(document.documentElement);
  const value = (name) => parseFloat(css.getPropertyValue(`--motion-${name}`));
  return { title: value("title"), body: value("body"), metadataDelay: value("metadata-delay"), bodyDelay: value("body-delay"), ease: css.getPropertyValue("--motion-ease").trim() };
};

export const focusTarget = (target) => {
  if (!target) return;
  if (!target.hasAttribute("tabindex")) {
    target.setAttribute("tabindex", "-1");
    target.addEventListener("blur", () => target.removeAttribute("tabindex"), { once: true });
  }
  target.focus({ preventScroll: true });
};